<template>

  <v-navigation-drawer
    v-if="getData"
    class="white"
    v-model="barOpen"
    hide-overlay
    right
    floating
    absolute
    :width="barOpen ? barSize : 0"
    disable-resize-watcher
    :data-testid="$options.name + '__navigation-drawer'"
  >

    <scroll-area>

      <template slot="header">
        <v-layout >
          <v-toolbar dense flat>
            <v-toolbar-title>
              <span class="body-2 text-uppercase">{{ getData.name }}</span>
            </v-toolbar-title>

                <v-layout fill-height justify-end align-center>

                  <v-tooltip dark color="secondary" bottom>
                    <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__toolbar' + '__btn' + '__replace'"
                      @click="dialog.replace.show = !dialog.replace.show">
                      <svg-icon
                        :color="'primary'"
                        :name="'move'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('replace') }}</span>
                  </v-tooltip>

                  <v-tooltip dark color="secondary" bottom>
                      <v-btn slot="activator" icon
                        :data-testid="$options.name + '__toolbar' + '__btn' + '__remove'"
                        @click="deleteCabinet()"
                      >
                        <svg-icon
                          :color="'red'"
                          :name="'basket'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{$t('delete')}}</span>
                  </v-tooltip>

                  <v-tooltip dark color="secondary" bottom>
                    <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__toolbar' + '__btn' + '__done'"
                      @click="updateCabinet">

                      <svg-icon
                        :color="'primary'"
                        :name="'done'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('save') }}</span>
                  </v-tooltip>

                  <v-tooltip dark color="secondary" bottom>
                    <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__toolbar' + '__btn' + '__close'"
                      @click="() => {$emit('close')}">
                      <svg-icon
                        :color="'primary'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('cancel') }}</span>
                  </v-tooltip>

                </v-layout>

          </v-toolbar>
        </v-layout>
      </template>

      <template slot="body">

        <v-container fluid fill-height ma-0 pa-0>

          <v-layout column fill-height>

            <v-tabs
              slider-color="primary"
              v-model="panel"
              height="40px"
              style="width: 100%"
              :data-testid="$options.name + '__tabs'"
            >

            <v-tabs-slider color="primary" style="height: 0px; max-width: 0px"></v-tabs-slider>

              <v-tab
                class="font-weight-normal"
                v-for="(place, index) in getPlaces"
                :key="index"
                :data-testid="$options.name + '__' + place + '_tab'"
              > 
                <template slot="default">
                  <div class="tab_wrapper">
                    <div :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'"
                      :data-testid="$options.name + '__' + place + '_tab_template'"
                    >
                      {{ $t(place) }} 
                    </div>
                  </div>
                </template>
              </v-tab>

            </v-tabs>

            <v-form ref="cabinet-form" :data-testid="$options.name + '__cabinet-form'" style="height: 100%">

              <v-layout column fill-height pt-2 ma-0>

                <v-layout v-for="(place, i) in getPlaces" :key="i" v-if="getPlaces[panel] == place" fill-height pa-0 ma-0>

                  <v-layout column v-show="place == 'main'">

                    <v-layout v-if="getFields" fill-height ma-0>

                      <v-flex xs12>

                        <v-layout column fill-height>

                            <v-layout shrink v-if="model.fields.name" px-2>
                              <v-flex xs4 shrink px-0 pb-2>
                                
                                <v-text-field
                                  :value="$t('name')"
                                  light
                                  outline
                                  flat
                                  readonly
                                  disabled
                                  class="backgrey"
                                  hide-details
                                  :rows="1"
                                  color="white"
                                >
                              
                                </v-text-field>
          
                              </v-flex>
          
                              <v-flex xs8 shrink px-0 pb-2>
                                      
                                <v-text-field
                                  v-model="model.obj.name"
                                  :data-testid="$options.name + '__' + place + '__text-field__name'"
                                  light
                                  :rules="[value => !!value || $t('required'), v => ((v || '' ).length <= 35 || (v || '' ).length == 0) || 'the number of characters in the name should not exceed', () => setErrorMessage('name', model.obj.name, 'поле ИМЯ должно быть заполнено, и не должно превышать 35 знаков')]"                          
                                  outline                               
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="accent"
                                >
                              
                                </v-text-field>
          
                              </v-flex>

                            </v-layout>

                            <v-layout shrink v-if="model.fields.comment" px-2>
                              <v-flex xs4 shrink px-0 pb-2>
                                
                                <v-text-field
                                :value="$t('comment')"
                                  light
                                  outline
                                  flat
                                  readonly
                                  disabled
                                  class="backgrey"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="white"
                                >
                              
                                </v-text-field>
          
                              </v-flex>
          
                              <v-flex xs8 shrink px-0 pb-2>
                                      
                                <v-text-field
                                  v-model="model.obj.comment"
                                  :data-testid="$options.name + '__' + place + '__text-field__comment'"
                                  light     
                                  outline
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="accent"
                                >
                              
                                </v-text-field>
          
                              </v-flex>

                            </v-layout>

                            <v-layout shrink v-if="model.fields.serial_number" px-2>
                              <v-flex xs4 shrink px-0 pb-2>
                                
                                <v-text-field
                                  :value="$t('serial_number')"
                                  light                 
                                  outline            
                                  flat
                                  readonly
                                  disabled
                                  class="backgrey"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="white"
                                >
                              
                                </v-text-field>
          
                              </v-flex>
          
                              <v-flex xs8 shrink px-0 pb-2>
                                      
                                <v-text-field
                                  v-model="model.obj.serial_number"
                                  :data-testid="$options.name + '__' + place + '__text-field__serial_number'"
                                  light
                                  outline
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="accent"
                                >
                              
                                </v-text-field>
          
                              </v-flex>

                            </v-layout>

                            <v-layout shrink v-if="model.fields.inventory_number" px-2>
                              <v-flex xs4 shrink px-0 pb-2>
                                
                                <v-text-field
                                  :value="$t('inventory_number')"
                                  light
                                  outline
                                  flat
                                  readonly
                                  disabled
                                  class="backgrey"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="white"
                                >
                              
                                </v-text-field>
          
                              </v-flex>
          
                              <v-flex xs8 shrink px-0 pb-2>
                                      
                                <v-text-field
                                  v-model="model.obj.inventory_number"
                                  :data-testid="$options.name + '__' + place + '__text-field__inventory_number'"
                                  light
                                  outline
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="accent"
                                >
                              
                                </v-text-field>
          
                              </v-flex>

                            </v-layout>

                            <v-layout shrink v-if="model.fields.allocated_power" px-2>
                              <v-flex xs4 shrink px-0 pb-2>
                                
                                <v-text-field
                                  :value="$t('allocated_power')"
                                  light
                                  outline
                                  flat
                                  readonly
                                  disabled
                                  class="backgrey"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="white"
                                >
                              
                                </v-text-field>
          
                              </v-flex>
          
                              <v-flex xs8 shrink px-0 pb-2>
                                      
                                <v-text-field
                                  v-model="model.obj.allocated_power"
                                  :data-testid="$options.name + '__' + place + '__text-field__allocated_power'"
                                  :type="'number'"
                                  light
                                  outline     
                                  class="white"
                                  persistent-hint
                                  hide-details
                                  :rows="1"
                                  color="accent"
                                >
                              
                                </v-text-field>
          
                              </v-flex>

                            </v-layout>

                            <v-flex shrink px-2 pb-2>
                              <v-checkbox small light color="secondary"
                                v-model="model.obj.available_ventilation_panel"
                                :data-testid="$options.name + '__' + place + '__checkbox__available_ventilation_panel'"
                              >
                                <template v-slot:label>
                                  <span class="black--text">{{$t('available_ventilation_panel')}}</span>
                                </template>
                              </v-checkbox>

                            </v-flex>

                            <v-layout column fill-height>

                              <v-flex py-0>

                                <scroll-area>

                                  <template slot="body">

                                    <v-layout shrink v-if="getFields" v-for="(field, name) in getFields" :key="name">
                                      
                                      <v-flex xs4 v-if="(field.type == 'select' || field.type == 'select_enum') && field.show == 'true' && field.name != 'template' && field.name.substring(0, 1) != '$' && field.place == getPlaces[panel]" shrink px-0 pb-2>
                                              
                                        <v-text-field
                                          :value="$t(field.name)"
                                          light
                                          outline
                                          flat
                                          readonly
                                          disabled
                                          class="backgrey"
                                          persistent-hint
                                          hide-details
                                          :rows="1"
                                          color="white"
                                        >

                                        </v-text-field>

                                      </v-flex>

                                      <v-flex xs8 v-if="(field.type == 'select' || field.type == 'select_enum') && field.show == 'true' && field.name != 'template' && field.name.substring(0, 1) != '$' && field.place == getPlaces[panel]" shrink px-0 pb-2>

                                        <v-select
                                          v-model="model.obj[field.name]"
                                          :data-testid="$options.name + '__' + field.type + '__select-field__' + field.name"
                                          light
                                          :readonly="field.name == 'depth' || field.name == 'usize'"
                                          :disabled="field.name == 'depth' || field.name == 'usize'"
                                          :items="getItems[field.cls]"
                                          :item-text="field.type == 'select' ? 'name' : 'value'"
                                          :item-value="field.type == 'select' ? '$id' : 'id'"
                                          :rules="field.required ? [value => !!value || $t('field must be filled'), () => setErrorMessage(field.name, model.obj[field.name], 'must be filled')] : []"
                                          outline
                                          hide-details
                                          class="white"
                                          background-color="backgrey"
                                          clearable
                                        >
                                          <template v-slot:item="{ item, index }">
                                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                          </template>
                                          <template v-slot:selection="{ item, index }">
                                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                                          </template>
                                        </v-select>

                                      </v-flex>

                                    </v-layout>

                                    <v-flex v-if="getFields">

                                      <v-flex xs12 px-2 py-0>

                                        <v-layout row fill-width justify-space-between align-center class="white pt-2">

                                          <v-flex v-if="field.type == 'timestamp'" v-for="(field, index) in getFields" :key="'date' + field.name" shrink px-2 py-0>

                                            <date-picker
                                              :value="model.obj[field.name]"
                                              :label="field.name"
                                              clearable
                                              @dateChange="(payload) => {onDateChange(payload, field.name)}"
                                            />

                                          </v-flex>

                                        </v-layout>

                                      </v-flex>

                                    </v-flex>

                                    <v-layout column>

                                      <v-flex xs12 pt-0>

                                        <v-flex shrink
                                          v-for="(field, index) in Object.keys(getTemplate)"
                                          :key="field + '_field' + index"
                                          v-if="field != 'id' && field != 'height' && field != 'width' && field != 'depth' && field != 'height_top' && field != 'height_bottom' && field.substring(0, 1) != '$'"
                                          px-2 pb-2
                                        >
                                          <v-text-field
                                            :value="$t(`${getTemplate[field]}`)"
                                            light  
                                            flat
                                            readonly
                                            class="white"
                                            background-color="white"
                                            hide-details
                                            outline
                                            rows="1"
                                          ></v-text-field>

                                        </v-flex>

                                      </v-flex>

                                    </v-layout>

                                  </template>

                                </scroll-area>

                              </v-flex>

                            </v-layout>

                        </v-layout>

                      </v-flex>

                    </v-layout>

                  </v-layout>

                  <v-layout column fill-height v-show="place == 'photo'">

                    <file-image
                      ref="file-image-component"
                      :image="getPreview"
                      edit
                      @select="(payload) => {onPhotoAdd(payload)}"
                    />

                  </v-layout>

                  <v-layout fill-height justify-start v-show="place == 'settings'" class="back">

                    <v-flex xs12 pa-0>

                      <v-layout column fill-height justify-start>

                        <location-settings
                          :data="getData"
                          @access="(payload) => {onAccessChanged(payload)}"
                          @accessDetails="(payload) => {onAccessDetailsChanged(payload)}"
                        />

                      </v-layout>

                    </v-flex>

                    <v-layout column fill-height justify-start>

                      <v-flex shrink v-if="getFields" v-for="(field, name) in getFields" :key="name + '_settings'">

                        <v-flex v-if="(field.type == 'select' || field.type == 'select_enum') && field.show == 'true' && field.name != 'template' && field.name.substring(0, 1) != '$' && field.place == 'settings'" px-2 pb-2>
                          <v-select
                            v-model="model.obj[field.name]"
                            :data-testid="$options.name + '_settings__' + field.name + '__select-field'"
                            light
                            :items="getItems[field.cls]"
                            :item-text="field.type == 'select' ? 'name' : 'value'"
                            :item-value="field.type == 'select' ? '$id' : 'id'"
                            :label="$t(name)"
                            class="white"
                            background-color="backgrey"
                            hide-details
                            outline
                            flat
                            clearable
                          >
                            <template v-slot:item="{ item, index }">
                                <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                            </template>

                          </v-select>

                        </v-flex>

                      </v-flex>

                    </v-layout>

                  </v-layout>

                </v-layout>
                
              </v-layout>

            </v-form>

          </v-layout>

        </v-container>

      </template>

    </scroll-area>

    <v-dialog  max-width="50%" 
      :data-testid="$options.name + '__dialog-form-file-import'"
      v-model="dialog.upload.show"
      v-if="dialog.upload.show">
        <form-file-import
          :newFiles="dialog.upload.files"
          :files="files"
          @close="onFileImportClose()"
          @upload="(payload) => onFileUpload(payload)"
        />
    </v-dialog>

    <v-dialog  max-width="50%" 
      :data-testid="$options.name + '__dialog-replace-card'"
      v-model="dialog.replace.show" 
      v-if="dialog.replace.show">
        <replace-card
          :data="data"
          @close="dialog.replace.show = false"
        />
    </v-dialog>

  </v-navigation-drawer>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import datePicker from '@/nms/components/controls/input-menu-datepicker.vue'
import FormFileImport from '@/nms/pages/forms/form-file-import.vue'
import fileImage from '@/nms/components/partials/file-image.vue'
import replaceCard from '@/nms/pages/cabinet/replace-card.vue'
import LocationSettings from '@/nms/pages/location/location-settings.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface ModelData {
  fields: Record<string, any>
  items: Record<string, any>
  obj: Record<string, any>
  refs: Record<string, any>
  image: any | null
}

interface DialogState {
  upload: {
    files: any[]
    show: boolean
  }
  replace: {
    show: boolean
  }
  confirm: boolean
}

interface StateMessages {
  error: Record<string, string>
}

interface StateData {
  messages: StateMessages
}

interface TemplateMap {
  [key: string]: any
}

interface MetaData {
  [key: string]: any
}

interface CabinetData {
  $id?: string
  id?: string
  name?: string
  template?: string
  [key: string]: any
}

interface FileItem {
  id?: string
  data?: {
    description?: string
  }
  [key: string]: any
}

interface UpdateData {
  [key: string]: any
}

export default Vue.extend({
  name: 'CABINET_BAR',

  components: {
    scrollArea,
    datePicker,
    FormFileImport,
    fileImage,
    replaceCard,
    LocationSettings,
    svgIcon
  },

  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: Number,
      default: () => 1000
    },
    data: {
      type: Object as () => CabinetData,
      default: () => ({})
    },
    closedUnits: {
      type: Array as () => any[],
      default: () => []
    },
  },

  data(): {
    barOpen: boolean
    barSize: number
    files: FileItem[]
    panel: number
    preview: boolean
    template: any
    templates: TemplateMap
    dialog: DialogState
    state: StateData
    meta: MetaData
    model: ModelData
  } {
    return {
      barOpen: false,
      barSize: 0,
      files: [],
      panel: 0,
      preview: false,
      template: {},
      templates: {},
      dialog: {
        upload: { files: [], show: false },
        replace: { show: false },
        confirm: false,
      },
      state: {
        messages: { error: {} }
      },
      meta: {},
      model: {
        fields: {},
        items: {},
        obj: {},
        refs: {},
        image: null,
      },
    }
  },

  computed: {
    getData(): CabinetData {
      return this.data
    },

    getTemplate(): any {
      return this.template || {}
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getItems(): Record<string, any> {
      return this.model.items
    },

    getPreview(): Array<{ url: string }> | FileItem[] {
      if (this.preview) {
        return [{ url: this.preview }]
      }
      return this.getPhoto
    },

    getPhoto(): FileItem[] {
      return this.files.filter(file => {
        const description = file.data?.description
        return description && description.split('.').shift() === 'image_$'
      })
    },

    getPlaces(): string[] {
      const store = this.$store.getters
      return store.getPlaces?.update?.cabinet || []
    },
  },

  watch: {
    open: {
      handler(newVal: boolean): void {
        const barWrapper = this.$parent.$refs?.['barWrapper'] as HTMLElement
        if (barWrapper) {
          this.barSize = barWrapper.clientWidth
        }
        this.barOpen = newVal
        if (newVal) {
          this.setup('WATCH open')
        }
      },
      deep: true
    },
    size: {
      handler(newVal: number): void {
        this.barSize = newVal
      },
      deep: true
    },
    data: {
      handler(newVal: CabinetData): void {
        if (!newVal) return
        this.setup('WATCH data', JSON.parse(JSON.stringify(newVal)))
      },
      deep: true
    },
  },

  created(): void {
    this.setup('created')
  },

  mounted(): void {
    document.addEventListener('keyup', this.closeOnESC)
    window.addEventListener('resize', this.resizeHandler)
  },

  beforeDestroy(): void {
    document.removeEventListener('keyup', this.closeOnESC)
    window.removeEventListener('resize', this.resizeHandler)
  },

  methods: {
    setup(caller?: string, val?: any): void {
      console.log(this.$options.name, 'setup', 'caller', caller, 'val', val)
      this.loadMeta('setup')
      this.loadTemplates()
    },

    async loadTemplates(): Promise<void> {
      try {
        this.setLoader('loadTemplates', true)
        const entityTemplates = await this.$bridge.getTemplates('cabinet') as any[]

        if (entityTemplates) {
          entityTemplates.forEach(template => {
            this.templates[template.id] = template
          })
          this.template = this.templates[this.data.template || '']
        } else {
          console.log(this.$options.name, 'updateCabinet', 'error', 'entity_templates', entityTemplates)
        }
        this.setLoader('loadTemplates', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadTemplates', err)
        this.setLoader('loadTemplates', false)
      }
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        this.setLoader('loadMeta', true)
        this.meta = await this.$loadMeta(this.getData)
        console.log(this.$options.name, 'loadMeta', 'caller', caller, 'this.meta', this.meta)

        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
        }
        await this.prepareData()
        this.setLoader('loadMeta', false)
      } catch (error) {
        this.setLoader('loadMeta', false)
        console.error('loadMeta error', error)
      }
    },

    async prepareData(): Promise<void> {
      try {
        this.setLoader('prepareData', true)
        const model = await this.$prepareData(this.model, this.getData, this.meta)
        if (model) {
          console.log(this.$options.name, 'prepareData', 'model', model)
          this.model = model
        }
        this.setLoader('prepareData', false)
      } catch (error) {
        this.setLoader('prepareData', false)
        console.error('CATCH', this.$options.name, 'prepareData', 'SMTH WRONG', error)
      }
    },

    async updateCabinet(): Promise<void> {
      const formRef = this.$refs['cabinet-form'] as any
      let valid = formRef?.validate() ?? false

      if (!valid) {
        if (Object.keys(this.state.messages.error).length) {
          Object.keys(this.state.messages.error).forEach(message => {
            this.$dialog.notify.error(this.state.messages.error[message], { timeout: 1000 })
          })
        } else {
          this.$dialog.notify.error(this.$getTranslate('error'), { timeout: 1000 })
        }
        return
      }

      const data_$ = Object.assign(this.model.obj, valid.valid)
      const keys = Object.keys(data_$)
      const data$: UpdateData = {}
      keys.forEach(key => {
        data$[key] = data_$[key]
      })

      if (this.model.image) {
        const photo = this.getPhoto
        if (photo.length) {
          this.setLoader('deleteDocument', true)
          await this.$bridge.deleteDocument(photo[0].id)
          this.setLoader('deleteDocument', false)
        }
        data$.files = this.model.image
      }

      try {
        this.setLoader('updateCabinet', true)
        const obj = await this.$bridge.getObjectById(this.getData.$id)

        if (obj) {
          const u = await obj.update(data$)
          if (u) {
            this.$dialog.notify.success('Успешно обновлено', { timeout: 5000 })
            this.$bridge.litePolling(obj.$id)
            this.$emit('update', obj)
          } else {
            this.$dialog.notify.error('Ошибка обновления', { timeout: 5000 })
            console.log(this.$options.name, 'updateCabinet', 'error', u)
          }
        } else {
          this.$dialog.notify.error('Ошибка обновления', { timeout: 5000 })
          console.log(this.$options.name, 'updateCabinet', 'error', 'obj$', obj)
        }
        this.setLoader('updateCabinet', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'updateCabinet', err)
        this.$errorHandler(err)
        this.setLoader('updateCabinet', false)
      }
    },

    onDateChange(payload: any, fieldName: string): void {
      this.$set(this.model.obj, fieldName, payload)
    },

    onPhotoAdd(e: Event): void {
      const target = e.target as HTMLInputElement
      if (!target.files?.length) return

      this.preview = window.URL.createObjectURL(target.files[0])
      const file = target.files[0] as any
      file.data = this.$merge({}, { description: 'image_$' })
      this.model.image = file
    },

    onFileAdd(payload: any): void {
      Object.keys(payload).forEach(index => {
        this.dialog.upload.files.push(payload[index])
      })
      this.$set(this.dialog.upload, 'show', true)
    },

    onFileUpload(payload: any[]): void {
      if (!payload) return
      payload.forEach(file => {
        this.files.push(file)
      })
      this.$set(this.dialog.upload, 'show', false)
    },

    onFileImportClose(): void {
      this.$set(this.dialog.upload, 'show', false)
      this.$set(this.dialog.upload, 'files', [])
    },

    async deleteCabinet(): Promise<void> {
      this.$dialog.confirm({
        text: `Удалить ${this.getData.name}?`,
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: async () => {
              try {
                this.setLoader('deleteCabinet', true)
                const obj = await this.$bridge.getObjectById(this.getData.$id)

                if (obj) {
                  const parent = await obj.getParent()
                  const d = await obj.delete()

                  if (d) {
                    this.$dialog.notify.success(this.$getTranslate('removal success'), { timeout: 5000 })

                    if(parent && parent.cls == 'folder') {
                      // console.log('ONCABINETUPDATE deleteCabinet parent folder')
                      this.$emit('update', parent)
                      await this.$store.dispatch('currentActiveTree', null)
                      await this.$store.dispatch('activeTree', null)
                      // this.$store.dispatch('loadTree')
                      this.$emit('close')
                    }
                    else {
                      await this.$store.dispatch('activeTree', parent)
                      this.$emit('update', parent)
                    }

                  } else {
                    this.$dialog.notify.error('Ошибка удаления', { timeout: 5000 })
                    console.log(this.$options.name, 'deleteCabinet', 'smth wrong', d)
                  }
                } else {
                  this.$dialog.notify.error('Ошибка удаления', { timeout: 5000 })
                  console.log(this.$options.name, 'deleteCabinet', 'obj$', 'smth wrong', obj)
                }
                this.setLoader('deleteCabinet', false)
              } catch (err) {
                this.$errorHandler(err)
                console.error('CATCH', this.$options.name, 'deleteCabinet', err)
                this.setLoader('deleteCabinet', false)
              }
            }
          }
        }
      })
    },

    onAccessChanged(payload: string): void {
      this.$set(this.model.obj, 'access', JSON.parse(payload))
    },

    onAccessDetailsChanged(payload: string): void {
      this.$set(this.model.obj, 'access_details', JSON.parse(payload))
    },

    closeOnESC(e: KeyboardEvent): void {
      if (e.which === 27 || e.keyCode === 27) {
        e.stopPropagation()
      }
    },

    setErrorMessage(name: string, value: any, err: string): boolean {
      console.log('setErrorMessage', name, value, err)

      if (name && err) {
        if (name === 'name') {
          if (value && String(value).length > 35) {
            this.$set(this.state.messages.error, name, this.$getTranslate(err))
          }
          if (value) {
            this.$set(this.state.messages.error, name, this.$getTranslate(err))
          }
        } else {
          if (!value) {
            console.log('setErrorMessage !value', name, value, err)
            this.$set(this.state.messages.error, name, `${this.$getTranslate('field')} ${this.$getTranslate(name)} ${this.$getTranslate(err)}`)
          }
        }
        return false
      }
      return true
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    resizeHandler(): void {
      const barWrapper = this.$parent.$refs?.['barWrapper'] as HTMLElement
      if (barWrapper) {
        this.barSize = barWrapper.clientWidth
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
